<template>

  <div>

    <v-dialog v-model="show_dialog_ref" max-width="70%">


      <v-card>
        <v-card-title>
          Recommended Screening Age
        </v-card-title>
        <v-card-text>


          <p>
            The U.S. Preventive Services Task Force recommends those 50 - 75 undergo regular screening.
            Note, however, that the American Cancer Society recently changed their recommended guidelines to include
            those 45 and above.
          </p>




          Source: US Centers for Disease Control and Prevention (CDC)<br>
          <a href="https://www.cdc.gov/cancer/colorectal/basic_info/screening/index.htm"
             target="_blank">
            https://www.cdc.gov/cancer/colorectal/basic_info/screening/index.htm
          </a>

          <br>
          Source: American Cancer Society <br>
          <a href="https://www.cancer.org/cancer/colon-rectal-cancer/detection-diagnosis-staging/acs-recommendations.html"
             target="_blank">
            https://www.cancer.org/cancer/colon-rectal-cancer/detection-diagnosis-staging/acs-recommendations.html
          </a>

        </v-card-text>

      </v-card>


    </v-dialog>











    <v-card max-width="900px">
      <v-card-title >
        Esophageal Dilation
      </v-card-title>
      <v-card-text  class="content-text">

        <div class="title">
          What Is It?
        </div>
        <!--<img src="@/assets/images/tmp/colonoscopy.jpg"  class="floated-image">-->
        <p>
          An  Esophageal Dilation is procedure that stretches the esophagus.  It typically is performed by
          inserting a special ballon into the esophagus which is then inflated to the desired degree.

        </p>


        <div class="title">
          Why Is It Performed?
        </div>
        <p>
          The esophagus can narrow due to a number of reasons the most common being scarring due to chronic GERD
          (Gastroesophageal Reflux Disease, aka acid reflux or heartburn).  When the esophagus is constricted, swallowing can be
          difficult and a sensation of food getting "stuck in the chest" can result.
        </p>


        <div class="title">
          What To Expect
        </div>
        <p>
          An Esophageal Dilation is  performed with the aid of an endoscope and therefore is often times
          performed alongside an EGD.  (Please see our page on EGD's for more info)
        </p>

        <p>
          Given that An Esophageal Dilation quite literally inflates the esophagus, there may be some residual
          soreness after the procedure.
        </p>


        <div class="title">
          Preparation
        </div>
        <p>

          Please see our EGD page for information on how to prepare.
        </p>


      </v-card-text>

    </v-card>
  </div>




</template>






<style scoped lang="scss">

  @use 'contentStyles';






</style>


<script>
// @ is an alias to /src


export default {
   data(){return {

      show_dialog_ref: false,

   }},



}
</script>
